import { Navigate, useParams } from "react-router-dom";

export default function FootballPlayerLegacyRedirect() {
  const { playerId, startYear } = useParams();
  return <Navigate to={`/oyuncular/${playerId}/${startYear}`} replace />;
}
